export default "__VITE_ASSET__DZGi6Fk6__"